import { useRef, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import FJVerticalScroller from '../../common/components/FJScroller/FJVerticalScroller';
import FJDropDown from '../../common/components/FJDropDown/FJDropDown';
import styles from './FJDropList.module.less';
import classNames from 'classnames';
import ArrowIcon from '../../assets/svg/button-right.svg?react';
import CheckIcon from '../../assets/svg/choose.svg?react';
import FJLocalStore from '../../store/FJLocalStore';

const FJDropList = props => {
    const {
        value,
        onChange,
        list = [],
        showCheckIcon = false,
        overlayWidth = 300,
        level = 1,
        listItemClassName,
        dropDownBoxClassName,
    } = props;
    const dropDownRef = useRef(null);
    // const [overlayWidth, setOverlayWidth] = useState(0);
    const _handleListClick = (e, item) => {
        e.stopPropagation();
        e.preventDefault();
        onChange(item);
        dropDownRef.current?.hide();
    };
    // useEffect(() => {
    //     if (dropDownRef.current && !overlayWidth) {
    //         setOverlayWidth(dropDownRef.current.triggerEle.current.offsetWidth);
    //     }
    // }, [overlayWidth]);
    const isActive = useCallback(
        item => {
            if (value?.value) {
                return item.value === value.value;
            } else if (value?.name) {
                return item.name === value.name;
            } else {
                return item.value === value;
            }
        },
        [value],
    );
    const curObj = useMemo(() => {
        return list.find(item => isActive(item));
    }, [list, isActive]);
    const _overlay = (
        <FJVerticalScroller className={styles.drop_down_list_box}>
            {list.map(item => {
                return (
                    <div
                        className={classNames(
                            styles.list_item,
                            isActive(item) && styles.list_item_active,
                            listItemClassName,
                        )}
                        key={item.name}
                        onClick={e => _handleListClick(e, item)}
                    >
                        {item.icon && <item.icon className={styles.list_item_icon} />}
                        <div className={styles.list_item_name}>{FJLocalStore._(item.name)}</div>
                        {showCheckIcon && isActive(item) && <CheckIcon className={styles.list_item_check_icon} />}
                    </div>
                );
            })}
        </FJVerticalScroller>
    );
    return (
        <FJDropDown
            triggerDisplay='flex'
            placement='bottomLeft'
            isTopLayer={true}
            level={level}
            trigger='click'
            overlayStyle={{
                width: overlayWidth,
            }}
            ref={dropDownRef}
            overlay={_overlay}
        >
            <div className={classNames(styles.drop_down_box, dropDownBoxClassName)}>
                <div className={styles.drop_down_content}>
                    {curObj?.icon && <curObj.icon className={styles.drop_down_content_icon} />}
                    {FJLocalStore._(curObj.name)}
                </div>
                <ArrowIcon className={styles.drop_down_content_arrow} />
            </div>
        </FJDropDown>
    );
};
FJDropList.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    list: PropTypes.array,
    showCheckIcon: PropTypes.bool,
    overlayWidth: PropTypes.number,
    level: PropTypes.number,
    listItemClassName: PropTypes.string,
    dropDownBoxClassName: PropTypes.string,
};

export default FJDropList;
